import { ImgProvider } from "assets/desktop/images/navSubgame";
import { ProviderLogo } from "assets/desktop/images/providerList";
import { SubGameType } from "types/game";

export const listBoardGame: SubGameType[] = [
  {
    game_code: "",
    name: "GR",
    provider_code: "GR",
    provider_name: "GR CHESS",
    type: "BG",
    featured: "",
    new_arrive: "",
    picture: ImgProvider.BoardGR,
    icon: ProviderLogo.GR,
  },
  {
    game_code: "",
    name: "GFGD",
    provider_code: "GFGD",
    provider_name: "Gordon CHESS",
    type: "BG",
    featured: "",
    new_arrive: "",
    picture: ImgProvider.BoardGFGD,
    icon: ProviderLogo.GFGD,
  },
  {
    game_code: "",
    name: "ATG",
    provider_code: "ATG",
    provider_name: "ATG CHESS",
    type: "BG",
    featured: "",
    new_arrive: "",
    picture: ImgProvider.BoardATG,
    icon: ProviderLogo.ATG,
  },
];
